var BYTES = {
  NULL: '\x00',
  LF: '\x0A'
};

module.exports = BYTES;
